import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: (builder) => ({

        // Section API
        getAllQASections: builder.mutation({

            query: (payload) => ({

                url: "qa/section/list",
                method: "POST",
                body: payload

            })

        }),

        getQASection: builder.mutation({

            query: (payload) => ({

                url: "qa/section/view",
                method: "POST",
                body: payload

            })

        }),

        createQASection: builder.mutation({

            query: (payload) => ({

                url: "qa/section/create",
                method: "POST",
                body: payload

            })

        }),

        updateQASection: builder.mutation({

            query: (payload) => ({

                url: "qa/section/update",
                method: "POST",
                body: payload

            })

        }),
        deleteQASection: builder.mutation({
            query: (payload) => ({
                url: "/qa/section/delete",
                method: "POST",
                body: payload
            })
        }),

        //Question API
        createQAQuestion: builder.mutation({
            query: (payload) => ({
                url: "qa/question/create",
                method: "POST",
                body: payload
            })
        }),

        updateQAQuestion: builder.mutation({
            query: (payload) => ({
                url: "qa/question/update",
                method: "POST",
                body: payload
            })
        }),

        getQAQuestion: builder.mutation({
            query: (payload) => ({
                url: "qa/question/get",
                method: "POST",
                body: payload
            })
        }),

        getAllQAQuestions: builder.mutation({
            query: (payload) => ({
                url: "qa/question/list",
                method: "POST",
                body: payload
            })
        }),
        deleteQAQuestion: builder.mutation({
            query: (payload) => ({
                url: "/qa/question/delete",
                method: "POST",
                body: payload
            })
        }),
    })
})

export const { useGetAllQASectionsMutation,
    useGetQASectionMutation,
    useCreateQASectionMutation,
    useUpdateQASectionMutation,
    useCreateQAQuestionMutation,
    useUpdateQAQuestionMutation,
    useGetQAQuestionMutation,
    useGetAllQAQuestionsMutation,
    useDeleteQASectionMutation,
    useDeleteQAQuestionMutation
} = Api
